import React from 'react';
import { withRouter } from 'react-router-dom';
import { triggerPageInit } from 'src/services/adManager';
import isOnboardingPath from './isOnboardingPath';
import isPhotobookPath from './isPhotobookPath';
import isPayoutPath from './isPayoutPath';

/**
 * Notifies Fuse on every SPA route change so it can refresh persistent
 * zones (sticky footer) and run auctions for the new page's zones.
 * Fuse requires fusetag.pageInit() after each navigation in SPAs.
 *
 * Exception: the onboarding flow (/start) is intentionally ad-free — its
 * sticky "Continue" button collides with Fuse's anchor unit on mobile — so we
 * skip pageInit when navigating there (mirrors the gate in index.html for cold
 * landings). The prize payout pages are ad-free for the same reason. Leaving
 * them re-inits ads normally.
 */
class RouteChangeAdRefresh extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname
      && !isOnboardingPath(this.props.location.pathname)
      && !isPhotobookPath(this.props.location.pathname)
      && !isPayoutPath(this.props.location.pathname)
    ) {
      triggerPageInit();
    }
  }

  render() {
    return null;
  }
}

export default withRouter(RouteChangeAdRefresh);
